import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Download, Loader } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

export interface ActionMenuItemProps {
  tooltipMessage: string;
  flashTooltip?: boolean;
  loading?: boolean;
  startIcon?: ReactNode;
  onClick?: () => void;
  destructive?: boolean;
}

const ActionMenuItem: FC<PropsWithChildren<ActionMenuItemProps>> = ({
  loading = false,
  onClick,
  startIcon = <Download />,
  children,
  destructive = false,
}) => {
  return (
    <DropdownMenuItem
      onClick={onClick}
      className={`group rounded-md px-2 py-1.5 cursor-pointer transition-colors duration-150 ${
        destructive
          ? 'focus:bg-destructive/10 hover:bg-destructive/10'
          : 'focus:bg-accent/80 hover:bg-accent/80 active:bg-accent'
      }`}
    >
      {loading && (
        <Loader
          className={`mr-2 h-3.5 w-3.5 animate-spin ${
            destructive ? 'text-destructive' : 'text-muted-foreground'
          }`}
        />
      )}
      {!loading && (
        <div
          className={`flex items-center justify-center mr-2 transition-colors duration-150 [&>svg]:h-3.5 [&>svg]:w-3.5 ${
            destructive
              ? 'text-destructive/70 group-hover:text-destructive'
              : 'text-muted-foreground group-hover:text-foreground'
          }`}
        >
          {startIcon}
        </div>
      )}
      <span
        className={`text-sm font-normal ${
          destructive ? 'text-destructive' : 'text-foreground'
        }`}
      >
        {children}
      </span>
    </DropdownMenuItem>
  );
};

export default ActionMenuItem;
